import styled from 'styled-components'

export const SidebarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 10px;
  cursor: pointer;
`
